<script>
    import { inventoryMethods } from '@state/helpers'
    import { mapGetters } from 'vuex'
    
    export default {
      name: 'Stock',
      components: {},
      data() {
        return {
          /* ------------- table product props ------------------- */
          tableheadersproducts: [
            { key: 'name', label: 'Nombre:', class: 'mw-100' },
            { key: 'id_ext1', label: 'Extensión:', class: 'mw-100' },
            { key: 'existence', label: 'Existencia:', class: 'mw-100' },
            { key: 'batchs', label: 'Lotes:', class: 'ws-100' },
          ],
          /* ------------- table inventory props ------------------- */
          tableheaders: [
            { key: 'batch', label: 'Lote(s)' },
            { key: 'serials', label: 'Serial(es)' },
            { key: 'existence', label: 'Existencia' },
            //{ key: 'actions', label: 'Acciones' },
          ],
          totalRows: 100,
          currentPage: 1,
          perpage: 5,
          pageOptions: [5, 15, 50, 100, 1000],
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
          filter: null,
          filterOn: 'serials',
          infoStockModal: {
            id: 'info-stock-modal',
            title: '',
            content: '',
          },
          items_by_batch: [],
          options: [
            { text: 'Item', value: 'batch' },
          ],
          /* --------------------------------------------- */
        }
      },
      computed: {
        ...mapGetters({
          own_stock: 'retina/inventory/own_stock',
          own_total_stock: 'retina/inventory/own_total_stock',
        }),
        sortOptions() {
          // Create an options list from our tableheaders
          return this.tableheaders
            .filter((f) => f.sortable)
            .map((f) => {
              return { text: f.label, value: f.key }
            })
        },
        transformedStock() {
          return this.own_stock.flatMap((item) => {
            const countGreaterThanZero = item.item.batchs.some((batch) => batch.count > 0);
            if (countGreaterThanZero) {
              // Si hay count mayor que 0, agrupa todos los batchs y serials en un solo item
              const batchs = item.item.batchs.reduce(
                (accumulator, batch) => {
                  if (batch.count > 0 && batch.serials.length>0) {
                    accumulator.batch.push(batch.batch);
                    accumulator.serial.push(...batch.serials);
                  } else {
                    if(batch.count > 0)
                    accumulator.individualBatchs.push({
                      item: {
                        ...item.item,
                        batchs: [batch],
                      },
                      batch: batch.batch,
                      assurance: batch.batch,
                      serial: batch.batch,
                      count: batch.count,
                      user: item.user,
                      lote:true
                    });
                  }
                  return accumulator;
                },
                { batch: [], serial: [], individualBatchs: [] }
              );
              const groupedItem = {
                ...item,
                item: {
                  ...item.item,
                  batchs: [
                    {
                      batch: batchs.batch.join(", "),
                      serials: batchs.serial,
                      assurance: item.item.batchs[0].batch,
                      quantity: item.item.batchs.reduce((total, batch) => total + batch.quantity, 0),
                      reserved: item.item.batchs.reduce((total, batch) => total + batch.reserved, 0),
                      count: item.item.batchs.reduce((total, batch) => total + batch.count, 0),
                    },
                  ],
                },
              };
              const filteredResult = [groupedItem].filter(
                (resultItem) => resultItem.item.batchs[0].serials.length > 0
              );
              return [...filteredResult, ...batchs.individualBatchs];
            }
          });
        }
      },
      mounted() {
        this.totalRows = this.own_total_stock
        for (let i = 0; i < 100; i++) {
          this.items_by_batch[i] = 0
        }
      },
      watch: {
        own_total_stock() {
          this.totalRows = this.own_total_stock
        },
      },
      methods: {
        ...inventoryMethods,
        has_serial(batchs) {
          if (batchs.serials.length > 0) return true
          return false
        },
        quantity(list) {
          // let i = 0
          // list.forEach((dict) => (i += dict.quantity))
          // return i
          return list.map(x => x.count).reduce((total, cant) => total + cant, 0)
        },
        verify_quantity(batchs, index) {
          if (this.items_by_batch[index] == 0) return null
          if (
            batchs.quantity >= this.items_by_batch[index] &&
            this.items_by_batch[index] > 0
          )
            return true
          return false
        },
        info(item, index, button) {
          this.infoStockModal.title = item.reference
          this.infoStockModal.content = item
          this.$root.$emit('bv::show::modal', this.infoStockModal.id, button)
        },
        resetinfoStockModal() {
          this.infoStockModal.title = ''
          this.infoStockModal.content = ''
        },
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length
          this.currentPage = 1
        },
        proccessRemoveItemInOwnStockByLote(item, batch, index) {
          this.removeItemInOwnStockByLote({
            item: item,
            batch: batch,
            lot_quantity: this.items_by_batch[index],
          })
          this.items_by_batch[index] = 0
        },
      },
    }
    </script>
    
    <template>
      <b-card no-body class="p-2">
        <b-card-title>  
          <i class="fas fa-dolly-flatbed"></i>
          Productos contados
        </b-card-title>
        <b-card-body class="p-0 px-1">
          <div class="row mb-2">
            <b-col lg="12" xl="6">
              <b-form-group
                label="Buscar"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
              >
                <b-input-group size="sm">
                  <b-form-input
                    placeholder="Serial..."
                    id="filter-input"
                    v-model="filter"
                    type="search"
                  ></b-form-input>
    
                  <b-input-group-append>
                    <b-button size="sm" :disabled="!filter" @click="filter = ''">
                      Limpiar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </div>
          <b-col lg="6" class="my-1 d-md-none px-0">
            <b-form-group
              label="Ordenar:"
              label-for="sort-by-select"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
              v-slot="{ ariaDescribedby }"
            >
              <b-input-group size="sm">
                <b-form-select
                  id="sort-by-select"
                  v-model="sortBy"
                  :options="sortOptions"
                  :aria-describedby="ariaDescribedby"
                  class="w-75"
                >
                  <template #first>
                    <option value="">Ninguno</option>
                  </template>
                </b-form-select>
    
                <b-form-select
                  v-model="sortDesc"
                  :disabled="!sortBy"
                  :aria-describedby="ariaDescribedby"
                  size="sm"
                  class="w-25"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
          <div class="row mt-3" style="color: #F28C02">
              Mostrando
            {{ !totalRows ? 0 : (currentPage - 1) * perpage + 1 }} -
            {{
              !totalRows
                ? 0
                : currentPage * perpage >= totalRows
                ? totalRows
                : currentPage * perpage
            }}
            de {{ totalRows }}
            productos
          </div>
    
          <div class="row mt-3">
            <b-table
              :items="transformedStock"
              :fields="tableheaders"
              :current-page="currentPage"
              :per-page="perpage"
              :filter="filter"
              :filter-included-fields="[filterOn]"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              empty-text="Sin registros para mostrar"
              empty-filtered-text="No se encontraron registros"
              stacked="md"
              show-empty
              small
              responsive
              sort-icon-left
              @filtered="onFiltered"
            >
              <template v-slot:cell(batch)="row">
                <p>{{row.item.item.batchs[0].batch}}</p>
              </template>
              <template v-slot:cell(serials)="row">
                <b-button size="sm" v-b-toggle="`collapse-${row.index}`">{{row.item.item.batchs[0].serials[0]}} 
                  <i class="fas fa-caret-down"></i></b-button>
                <b-collapse :id="`collapse-${row.index}`" class="mt-2">
                  <div class="container-serials">
                    <p class="card-text" v-for="(serial, index) in row.item.item.batchs[0].serials">-{{serial}}</p>
                  </div>
                </b-collapse>
              </template>
              <template v-slot:cell(existence)="row">
                <span >{{ row.item.item.batchs[0].count }}</span>
              </template>
              <!--<template v-slot:cell(actions)="row">
                <b-button
                  :id="`update-btn-${row.index}`"
                  v-b-tooltip.hover.v-primary.bottom="'Eliminar'"
                  @click="removeItemInOwnStockBySerial({
                            index: row.index
                          })"
                          variant="link"
                          size="sm"
                          class="ml-1 d-inline align-items-center"
                >
                  <i class="fas fa-minus-circle mr-1"></i>
                </b-button>
              </template>-->
            </b-table>
          </div>
          <b-row class="mb-2">
            <b-col sm="6" lg="6" xl="6">
                Registros<span class="d-none d-lg-inline"> por página</span>
                <b-form-select
                  id="per-page-select"
                  v-model="perpage"
                  :options="pageOptions"
                  size="sm"
                  class="ml-2"
                  style="max-width: 60px"
                ></b-form-select>
            </b-col>
            <b-col sm="6" lg="6" xl="6">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perpage"
                align="right"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </template>
    <style>
      .card-text{
        padding-left: 10px;
      }
      .container-serials{
        max-height: 100px;
        overflow: auto;
      }
    </style>